import renderComponent from '../renderComponent';
import App from '../apps/ask/App';

renderComponent(App, 'ask-app');
